import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useControlledValue } from "../../hooks/_private/useControlledValue";
import { classNames } from "../../utils/helpers";
import s from './Toggle.module.css';
export const Toggle = ({ attributes, checked, className, defaultChecked, disabled, inputAttributes, inputClassName: passedInputClassName, name, onChange, onValueChange, }) => {
    const rootClassName = classNames(s.root, className);
    const inputClassName = classNames(s.input, passedInputClassName);
    const [controlledChecked, setControlledChecked] = useControlledValue({
        defaultValue: defaultChecked,
        value: checked,
        onValueChange,
    }, false);
    const handleChange = (event) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
        setControlledChecked(event.target.checked);
    };
    return (_jsxs("div", Object.assign({ className: rootClassName, "data-testid": "st-toggle" }, attributes, { children: [_jsx("input", Object.assign({ checked: controlledChecked, className: inputClassName, disabled: disabled, name: name, role: "switch", type: "checkbox", onChange: handleChange }, inputAttributes)), _jsx("span", { className: s['toggle-background'] }), _jsx("span", { className: s['toggle-knob'] })] })));
};
